import styled from 'styled-components';

import { colorUsage, fontSize, getSpacing, letterSpacing } from 'stylesheetB2c';

export const StyledHelpLink = styled.div`
  display: flex;
  align-items: center;
  color: ${colorUsage.infoGrey};
  cursor: pointer;
`;
StyledHelpLink.displayName = 'StyledHelpLink';

export const HelpLabel = styled.div`
  font-size: ${fontSize.small};
  text-decoration: underline ${colorUsage.infoGrey};
  margin-right: ${getSpacing(1)};
  letter-spacing: ${letterSpacing.medium};
`;
